import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { TransferState, makeStateKey } from '@angular/core';
// rxjs
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs';
// import 'rxjs/add/operator/catch';
// import 'rxjs/add/operator/take';
//import 'rxjs/add/operator/retry';
import { take, takeWhile, map, catchError, retry } from 'rxjs/operators';

// models
import { AppState } from '../../booking/models/app-state.interface';
import { CopyDataInitState } from '../models/copy.interface';
// path globals
import { API_PATH, SUBSCRIPTION_KEY, SYSTEM_OBJECTS, GET_COPY_DATA, GET_STATIC_COPY_DATA, ABC_PARTNERS } from '../globals';
import { COPY_LOADED } from '../reducers/loading-status.reducer';
// server state key
const COPY_KEY = makeStateKey('copy');

var copyResponseData = null;

@Injectable({
  providedIn: 'root',
})
export class CopyService {

  private _token;
  private _copyRequested;
  private _copyStoreData: CopyDataInitState = null;

  public copyData$: Subject<any> = new Subject();

  constructor(
    private _appStore: Store<AppState>,
    private _http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object,
    private _serverState: TransferState
  ) { }


  getCopy(request: any) {
    this.getStaticCopy();
  }

  getStaticCopy() {
    if (this._copyRequested) { return; }
    this._copyRequested = true;
    this._http.get(GET_STATIC_COPY_DATA)
      .subscribe((res: any) => {
        // // console.log('res print here', res)
        const copyStoreData: CopyDataInitState = res;
        this._copyStoreData = res;
        copyStoreData.copyLoaded = true;
        copyResponseData = copyStoreData;
        this._appStore.dispatch(COPY_LOADED({copyLoaded : true}));
      });
  }

  getCopyBySection(carrier: string, page: string, tags: Array<string>) {

    let copyData: Array<Object> = [];
    // // console.log(carrier, page, tags)
    if (typeof page === 'undefined' || typeof carrier === 'undefined') {
      return;
    }

    if (ABC_PARTNERS.find(partner => partner.code === carrier.toLocaleUpperCase())) {
      copyData = this.extractCopyFromData(carrier, page, tags);
    } else {
      carrier = 'OTHER';
      copyData = this.extractCopyFromData(carrier, page, tags);
    }

    if (copyData.length === 0) { copyData.push({}); }

    return copyData;

  }

  extractCopyFromData = (c, p, t) => {
    // // console.log(c, p, t);

    const airlineCopy = copyResponseData.airlines;
    let matchCount = 0;
    const returnedData = [];
    const matchCountArr = [];

    for (const item of airlineCopy) {
      if (item['carrier'].toLocaleUpperCase() === c.toLocaleUpperCase()) {
        for (const page of item.pages) {
          if (page['page'].toLocaleUpperCase() === p.toLocaleUpperCase()) {
            for (const section of page.sections) {
              matchCount = 0;
              // count matches of tags
              for (const tag of section.tags) {
                t.map((i) => { if (i.toLocaleUpperCase() === tag.toLocaleUpperCase()) { matchCount++; } });
              }
              // if matches > 0
              // push into arr
              if (matchCount > 0) {
                section.matches = matchCount;
                returnedData.push(section);
              }
            }
            // sort arr - most matches to start of array
            returnedData.sort((a, b) => { return a.matches < b.matches ? 1 : -1; });
          }
        }
      }
    }

    return returnedData;

  }


  getCopyByCarrier(carrier: string) {

    let copyData: any = null;

    if (ABC_PARTNERS.find(partner => partner.code === carrier.toLocaleUpperCase())) {
      const storeData = copyResponseData;
      const copyIndex = storeData.copyReducer.carrierKey[carrier.toLocaleUpperCase()];
      copyData = storeData.copyReducer.airlines[copyIndex];
    }

    return copyData;
  }

  getLatestCopyFromStore(store: Store<AppState>) {
    let state: AppState;
    store.pipe(take(1)).subscribe(s => state = s);
    return state;
  }

}
